var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 33.333,
    viewBox: "0 0 50 33.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ticket2-default",
    d: "M51.917,22.583A2.089,2.089,0,0,0,54,20.5V12.167A4.179,4.179,0,0,0,49.833,8H8.167A4.179,4.179,0,0,0,4,12.167V20.5a2.089,2.089,0,0,0,2.083,2.083,2.083,2.083,0,1,1,0,4.167A2.089,2.089,0,0,0,4,28.833v8.333a4.179,4.179,0,0,0,4.167,4.167H49.833A4.179,4.179,0,0,0,54,37.167V28.833a2.089,2.089,0,0,0-2.083-2.083,2.083,2.083,0,0,1,0-4.167ZM8.167,37.167V30.542a6.225,6.225,0,0,0,0-11.75V12.167h12.5v25ZM49.833,18.792a6.225,6.225,0,0,0,0,11.75v6.625h-25v-25h25Z",
    transform: "translate(-4 -8)",
    fill: "#00c1d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket1);
export default __webpack_public_path__ + "static/media/ticket-1.38398f89a4cff18fbc12954e42b48c57.svg";
export { ForwardRef as ReactComponent };